module.exports = __webpack_public_path__ + "dash_20_app_assets/img/ye.046d6502.png";